// 法人信息
import { i18n } from '@/common/utils/i18n'
import { get, isNumber } from 'lodash-es'
import { LEGAL_TYPE_OPTINS } from '@/config-JP/sign/enums'
import {getFormatTimeByPattern} from '@didi/elvish-lib-javascript'

let filter = (list, target) => {
  return list.filter((item) => {
    return +item.value === +target
  })
}

export default (state) => {
  let contractInfo = get(state, 'currentContractorDetail.contractInfo', {})
  let legalType = filter(LEGAL_TYPE_OPTINS, contractInfo.legalType)
  return {
    title: i18n.gettext('法人信息'),
    content: [
      {
        title: i18n.gettext('法人姓名'),
        label: `${contractInfo.legalLastName} ${contractInfo.legalName} (${contractInfo.legalLastNameAlph} ${contractInfo.legalNameAlph})`
      },
      {
        title: i18n.gettext('出生日期'),
        label: isNumber(contractInfo.legalBirth) ? getFormatTimeByPattern(contractInfo.legalBirth, 'yyyy-MM-dd') : ''
      },
      {
        title: i18n.gettext('证件类型'),
        label: contractInfo.legalType ? (legalType.length > 0 && legalType[0].text) || '' : ''
      },
      {
        title: i18n.gettext('证件照片'),
        content: i18n.gettext('查看'),
        isLink: true,
        arrow: true,
        pics: contractInfo.legalPics
      }
    ]
  }
}
